module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 131.5bfe4d83.png";